import { watch } from 'vue';

export default {
  created() {
    if (!this.$i18n || typeof this.$options.data !== 'function') return;

    const rawDataFn = this.$options.data;
    const initialData = rawDataFn.call(this);

    this.__i18nArrayKeys = [];

    for (const key in initialData) {
      const value = initialData[key];
      if (Array.isArray(value)) {
        const hasTranslatedString = value.some(
          item =>
            item &&
            typeof item === 'object' &&
            Object.values(item).some(
              v =>
                typeof v === 'string' &&
                this.__isProbablyTranslated(v)
            )
        );

        if (hasTranslatedString) {
          this.__i18nArrayKeys.push(key);
        }
      }
    }

    watch(
      () => this.$i18n.locale,
      () => {
        const newData = rawDataFn.call(this);
        this.__i18nArrayKeys.forEach(key => {
          if (newData[key]) {
            this[key] = newData[key];
          }
        });
      }
    );
  },

  methods: {
    __isProbablyTranslated(text) {
      return (
        typeof text === 'string' &&
        /[A-ZÇĞİÖŞÜa-zçğıöşü\s.,:;!?]/.test(text) &&
        text.length > 1
      );
    }
  }
};
